// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import "./icon/iconfont.css" //引入阿里巴巴矢量图标库
import moment from 'moment'
import md5 from './assets/js/md5.js'
import response from './assets/js/response.js'
import store from './vuex/Cookie_vuex'
import Blob from './excel/Blob'
import Export2Excel from './excel/Export2Excel.js'
//
import saveLogin from './assets/js/saveLogin.js'
//编辑框
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

Vue.use(mavonEditor)

Vue.use(md5)

Vue.prototype.response = response

Vue.prototype.saveLogin = saveLogin

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

Vue.filter('formatDate', function(dates, pattern = 'YYYY-MM-DD HH:mm:ss') {
    return moment(dates).format(pattern)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js